import type { GameCode } from '../../entities/room/types';

/**
 * Per-game icon glyphs v2 — DS D4 language (DESIGN_SYSTEM.md + brand-unify
 * artifact): 1.9px round-cap strokes, one signature color per game, pure
 * geometry. Replaces the legacy raster-flavored art across lobby / room
 * chrome / archive chips.
 *   lastdigit — two stacked digit tiles (front "7"), rose
 *   sicbo     — slightly tilted die showing 5, amber
 *   roulette  — spoked wheel with the green zero-pocket dot, red
 */
const GAME_ICON_SVG: Record<GameCode, string> = {
  lastdigit: `
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="100%" height="100%" fill="none" stroke="#fb7185" stroke-width="1.9" stroke-linecap="round" stroke-linejoin="round">
      <rect x="7.2" y="4.6" width="13.2" height="15.8" rx="3" opacity="0.38"/>
      <rect x="3.6" y="3.6" width="13.6" height="16.8" rx="3"/>
      <path d="M7.6 8.2 H13.4 L9.4 15.8"/>
    </svg>`,
  sicbo: `
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="100%" height="100%">
      <g transform="rotate(-8 12 12)">
        <rect x="4.6" y="4.6" width="14.8" height="14.8" rx="3.4" fill="none" stroke="#fbbf24" stroke-width="1.9"/>
        <g fill="#fbbf24">
          <circle cx="8.6" cy="8.6" r="1.35"/><circle cx="15.4" cy="8.6" r="1.35"/>
          <circle cx="12" cy="12" r="1.35"/>
          <circle cx="8.6" cy="15.4" r="1.35"/><circle cx="15.4" cy="15.4" r="1.35"/>
        </g>
      </g>
    </svg>`,
  roulette: `
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="100%" height="100%" fill="none" stroke="#e05a5a" stroke-width="1.7" stroke-linecap="round">
      <circle cx="12" cy="12" r="8.8"/>
      <circle cx="12" cy="12" r="5"/>
      <path d="M12 3.2 V7 M12 17 V20.8 M3.2 12 H7 M17 12 H20.8 M5.8 5.8 L8.5 8.5 M18.2 5.8 L15.5 8.5 M5.8 18.2 L8.5 15.5 M18.2 18.2 L15.5 15.5"/>
      <circle cx="12" cy="12" r="1.7" fill="#e05a5a" stroke="none"/>
      <circle cx="15.4" cy="6.2" r="1.4" fill="#3db468" stroke="none"/>
    </svg>`,
};

export function GameIcon({ game, className }: { game: GameCode; className?: string }) {
  return (
    <span
      className={`game-icon${className ? ` ${className}` : ''}`}
      aria-hidden="true"
      dangerouslySetInnerHTML={{ __html: GAME_ICON_SVG[game] || '' }}
    />
  );
}
